import * as z from 'zod';
export const CorrectGuessesSchema = z.object({
    normalizedNames: z.array(z.string()),
});
export const SetCorrectGuessesBodySchema = z.object({
    normalizedNames: z.array(z.string().min(1)),
});
export const DrawEntrySchema = z.object({
    userId: z.uuidv7(),
    drawId: z.uuidv7(),
    ordering: z.int(),
    status: z.enum(['winner', 'candidate']),
    selectedAt: z.int().nullable(),
    identityType: z.enum(['Adult', 'Child']),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string().nullable(),
    birthYear: z.int().nullable(),
});
export const DrawSchema = z.object({
    entries: z.array(DrawEntrySchema),
});
export const SetWinnerSchema = z.object({
    userId: z.uuidv7(),
});
//# sourceMappingURL=result.js.map